"use strict";

exports.__esModule = true;
exports.If = void 0;

var Term_1 = require("../Term");

exports.If = new Term_1.Term('If', 'IF', 'if', {
  unique: true
});